module.exports = __webpack_public_path__ + "img/banner.f13cfb2a.png";